import {Feature} from './features/features';
import {Warning} from "./warning";

export enum Languages {
  en = 'en',
  pt = 'pt',
  zh = 'zh',
  ja = 'ja',
  es = 'es'
}

export interface IProjectTypeSelector {
  label: string;
  icon?: string;
  toolTip?: string;
  catalog?: string;
  classType?: string;
  filterTopologies?: string[];
  url?: string;
  url_label?: string;
  nodes?: Array<IProjectTypeSelector>;
}

export interface IBounds {
  min: number;
  max: number;
  typical?: number;
}

export interface IKeyValuePair {
  key: string;
  value?: any;
}

export interface InfoToShow {
  dataName: {
    label: string;
    value: string;
    unit: string;
  };
}

export interface IDesignValidator {
  implementerClass: string;
  power?: {
    min?: number;
    max?: number;
    maxEurope?: number;
    maxWide?: number;
  };
  min_max_ratio_perc?: number;
}

export interface ISwitchingFrqParam {
  dMax?: number;
  ton_min?: number;
  fosc_def?: number;
  fosc_min?: number;
  fosc_max?: number;
  fsync_def?: number;
  fsync_min?: number;
  fsync_max?: number;
}

export interface IResourcePath {
  path: string;
  name: string;
}

export interface IDesignSolution {
  key: string;                   // partNumber + ":" + topology //to evaluate + application class
  RPN: string;
  partNumber: string;
  packageName: string;
  packageImage: IResourcePath;

  topology: string;
  collection: string[];           // added to implement the filter on the catalog
  shownInfo: InfoToShow[];

  schematic: IResourcePath;
  description: string;

  datasheet: string;
  productFolder?: string;

  logo?: string;

  note?: IEntityAlert;
  warning: Warning;
  visibleOnGrid?: string;
}

export interface ITranslatedFeature {
  feature_contents: any[];
  feature_name: string;
  feature_title: string;
}

export interface ITranslatedFeaturesAndDescription {
  description: string;
  featuresAndDescription: {
    features: ITranslatedFeature[],
    description: string
  };
}

export interface Ic extends IDesignSolution {
  CPN: string;
  referenceDesign?: string;
  efficiency: number;
  efficiencyState: string;
  id: string;
  releaseDate: string;
  status?: string;
  app_name?: string;
  fsw?: ISwitchingFrqParam;
  iout_max: number;
  vin_min: number;
  vin_max: number;
  vout_min: number;
  vout_max: number;
  vouts?: number[];
  features: Array<Feature>;
  schematicSwf: string;
  packageImageSwf: string;
  designModule?: any;
  designData: any;
  loadingLocalizedDesc: boolean;
  descriptions: {
    en: ITranslatedFeaturesAndDescription,
    zh: ITranslatedFeaturesAndDescription,
    ja: ITranslatedFeaturesAndDescription
  };
  validator?: IDesignValidator;
  visibleOnGrid?: string;
}

export interface ITranslatedObj {
  key: string;
  data?: any;
}

export interface IEntityAlert {
  info?: string[];
  warning?: string[];
  hasMessage: boolean;
  hasInfo: boolean;
  hasError: boolean;
  hasWarning: boolean;
  translatedErrors: ITranslatedObj[];
}

export interface IAppTypeMap {
  apps: [{
    app: {
      name: string;
      url: string;
      baseUrl?: string;
      specApp: string;
    }
  }];
}

export interface ILedInfo {
  Manufacturer: string;
  Family: string;
  PN: string;
  VF: string;
  VFMax: string;
  IF: string;
  Rd: string;
  Color: string;
  Flux: string;
  URL_Manufacturer: string;
  URL_PN: string;
}
